export const HERO_TITLE_CLASS =
    "text-[40px] lg:text-[76px] leading-[48px] lg:leading-[91.20px] uppercase font-bold font-Montserrat text-Text_White";
